export default "__VITE_ASSET__b48cfd38__"